import request from '../request'

export const authApi = {
  // 用户登录
  login (credentials) {
    return request.post('user/login', credentials)
  },

  // 用户登出
  logout () {
    return request.post('user/logout')
  },

  // 获取用户信息
  getUserInfo () {
    return request.get('user/info')
  },

  // 修改密码
  changePassword (data) {
    return request.post('user/changePassword', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/auth.js